import { render, staticRenderFns } from "./CustomSelect.vue?vue&type=template&id=00f3d5b2&scoped=true"
import script from "./CustomSelect.vue?vue&type=script&lang=ts"
export * from "./CustomSelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00f3d5b2",
  null
  
)

export default component.exports